import React from 'react';
import '../styles/Navbar.css';

function Navbar() {
    return (
        <nav className="navbar">
            <div className = "nav-logo">
                Brilliant <span>Beauty</span>
            </div>

            <div className = "nav-links">
                <a href="#services">Services</a>
                <a href="#booking">Book</a>
                <a href="#gallery">Gallery</a>
                <a href="#contact">Contact</a>
            </div>

            <button className="nav-book">Book Now</button>
            </nav>
    );
}

export default Navbar;